import React, { useCallback, useRef, useEffect, useState } from 'react';
import { FiLogIn, FiMail, FiLock, FiUser } from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
// import logo from '../../assets/logo-compressed.png';

import { logo } from '../../config';
import { Container, Content, Background, AnimatedDiv2 } from './styles';
import Input from '../../components/Input';
import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';

import { Pattern } from '../../styles/ThemeComponents';
import ShowDiv from '../../components/ShowOnScroll';
import Logo from '../../components/Logo';
import MaskedInput from '../../components/MaskedInput';
import { FaIdBadge } from 'react-icons/fa';
import Whatsapp from '../../components/Whatsapp';

interface SignInData {
  email: string;
  password: string;
  name: string;
  cpf : string;
}

const SignIn: React.FC = () => {
  const history = useHistory();
  const [withPassword, setWithPassword] = useState(false);
  const { signIn } = useAuth();
  const { addToast } = useToast();
  const formRef = useRef<FormHandles>(null);

  const handleSubmit = useCallback(
    async (data: SignInData) => {
      try {
        formRef.current?.setErrors({});

        const shape = withPassword
          ? {
              email: Yup.string()
                .required('Email obrigatório')
                .email('Preencha um email válido'),
              password: Yup.string().required('Senha obrigatória'),
              
            }
          : {
              email: Yup.string()
                .required('Email obrigatório')
                .email('Preencha um email válido'),
 
            };

        const schema = Yup.object().shape(shape);

        await schema.validate(data, { abortEarly: false });

        const { email, name,password,cpf } = data;

 

        await signIn({ email, password, name, cpf: '' });
        window.location.href = '/dashboard';
        return;
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
        }

        addToast({
          type: 'error',
          title: 'Erro na autenticação',
          description: 'Ocorreu um erro ao fazer login',
        });
      }
    },
    [signIn, addToast, history],
  );
  return (
    <Container>
      <Content>
        <AnimatedDiv2>


          <Form ref={formRef} onSubmit={handleSubmit}>
            <img src="/assets/evento/capa/nome.png"/>
            <h2>Acessar</h2>

            <Input icon={FiMail} name="email" placeholder="E-mail" />
   
            {withPassword && (
              <Input
                icon={FiLock}
                name="password"
                type="password"
                placeholder="senha"
              />
            )}
            <Button type="submit" style={{width:"100%"}}>Entrar</Button>
<p style={{width: "100%", maxWidth:"350px", margin: "5px auto", background: "rgb(50, 70, 107)", color: "#fff", padding:"10px"}}>Cada email dá acesso a 1 participante</p>
<Whatsapp message="Suporte Técnico" text={`Olá, estou na III Jornada Latino-Americana`}/>
          </Form>
        </AnimatedDiv2>
      </Content>
    </Container>
  );
};
export default SignIn;
